import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

// 子路由引入
import registerRoutes from '@/router/business/purchase/register'
import generateBiddingRoutes from '@/router/business/purchase/bidding-fun'
import generateInquiryRoutes from '@/router/business/purchase/inquiry-fun'
import generateNegotiationRoutes from '@/router/business/purchase/negotiation-fun'
import directRoutes from '@/router/business/purchase/direct'
import generateCompeteRoutes from '@/router/business/purchase/compete-fun'
import supplementRoutes from '@/router/business/purchase/supplement'
import demandsRoutes from '@/router/business/purchase/demands'

/**
 * 采购交易，即云采购的招标采购
 */
export default {
  path: 'purchaser',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '采购交易',
    layout: 'DefaultLayout'
  },
  applicableCompanyTypes: [
    { companyType: companyTypeDict.ENTERPRISE.value },
    { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
  ],
  platformAlias: [],
  applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
  roles: [
    platformFunctionModuleDict.PURCHASER.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
  ],
  superviseInstitutions: [],

  children: [
    // 项目登记
    registerRoutes,
    // 招标采购
    generateBiddingRoutes(),
    // 询比采购
    generateInquiryRoutes(),
    // 谈判采购
    generateNegotiationRoutes(),
    // 单一来源采购
    generateBiddingRoutes('source', 'Source', '单一来源采购'),
    // 直接采购
    directRoutes,
    // 竞价采购
    generateCompeteRoutes(),
    // 备案采购
    supplementRoutes,
    // 采购需求
    demandsRoutes
  ]
}
